import { render, staticRenderFns } from "./InviteAccountPage.vue?vue&type=template&id=2d3377c2&"
import script from "./InviteAccountPage.vue?vue&type=script&lang=js&"
export * from "./InviteAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3377c2')) {
      api.createRecord('2d3377c2', component.options)
    } else {
      api.reload('2d3377c2', component.options)
    }
    module.hot.accept("./InviteAccountPage.vue?vue&type=template&id=2d3377c2&", function () {
      api.rerender('2d3377c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/InviteAccountPage.vue"
export default component.exports